






















































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import brandModule from '../../store/modules/brand.module';

@Component
export default class ScheduleMeetingDialog extends Vue {
  @Prop({ default: -1 }) firstPage!: number;

  dialog = false;

  datePicker = new Date().toISOString().substr(0, 10);

  timePicker = null;

  dateSelected = false;

  appointmentSubmitted = false;

  dateTimeScheduled = false;

  currentPage = -1;

  chosenContact = {};

  employees = [
    { text: 'John Smith', value: 1 },
    { text: 'Jane Doe', value: 2 },
    { text: 'Jack Johnson', value: 3 },
    { text: 'Bill Nye', value: 4 },
  ];

  interests = [
    'CBD Gummies',
    'Flower',
    'Collaborate',
    'Edibles',
    'Extracts',
    'Other',
  ];

  email = '';

  get brandSecondaryColor() {
    if (!brandModule.brand) {
      return '#293645';
    }
    return brandModule.brand.secondary_color;
  }

  mounted(): void {
    this.currentPage = this.firstPage;
  }

  backWasSelected() {
    this.currentPage -= 1;
  }

  nextWasSelected() {
    this.currentPage += 1;
  }

  submitAppointment() {
    this.nextWasSelected();
    this.appointmentSubmitted = true;
    this.$emit('appointmentSubmitted', true);
  }
}
